import React from 'react';
import { Link } from 'react-router-dom';
import DisplayTour from '../displayTour';
import DisplayTourGuide from '../displayTourGuide';
import { useTranslation } from 'react-i18next';

const Profile = ({ tourGuideProfile, locations }) => {
    return (
        <div className="profile-section">
            <div className="d-flex justify-content-between align-items-start mb-4">
                <DisplayTourGuide tourguide={tourGuideProfile} locations={locations} />
                <Link to="/tourguide/edit" className="btn-outline">
                    <i className="bi bi-pencil me-2"></i>Edit Profile
                </Link>
            </div>
        </div>
    )
}

const MySchedule = () => {
    return (
        <div className="schedule-section">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Upcoming Tours</h2>
            </div>
            <div className="empty-state">
                <i className="bi bi-calendar3"></i>
                <p>No upcoming scheduled tours.</p>
                <p className="text-muted small">Schedule dates for your tours to start accepting bookings.</p>
            </div>
        </div>
    )
}

const MyTours = ({ tours }) => {
    const { t } = useTranslation();
    
    return (
        <div className="tours-section">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>{t('tourguide-my-tours')}</h2>
                <Link to="/tourguide/tours/create" className="btn-primary">
                    <i className="bi bi-plus-lg me-2"></i>{t('tourguide-create-tour')}
                </Link>
            </div>
            
            {tours && tours.length > 0 ? (
                <div className="tours-grid">
                    {tours.map((tour) => (
                        <Link to={"/tourguide/tours/" + tour.id} key={tour.id} className="tour-link">
                            <DisplayTour tour={tour} compact={true} />
                        </Link>
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <i className="bi bi-map"></i>
                    <p>{t('tourguide-no-tours')}</p>
                    <Link to="/tourguide/tours/create" className="btn-primary mt-3">
                        <i className="bi bi-plus-lg me-2"></i>Create Your First Tour
                    </Link>
                </div>
            )}
        </div>
    )
}

const ProfileView = ({ tourGuideProfile, activeTab, handleTabClick, tours, locations }) => {
    const { t } = useTranslation();
    
    return (
        <div className="profile-view">
            <ul className='nav nav-tabs'>
                <li className="nav-item">
                    <a 
                        className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`}
                        onClick={() => handleTabClick('tab1')}
                        href="#tab1"
                    >
                        <i className="bi bi-calendar3 me-2"></i>{t('tourguide-schedule')}
                    </a>
                </li>
                <li className="nav-item">
                    <a 
                        className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`}
                        onClick={() => handleTabClick('tab2')}
                        href="#tab2"
                    >
                        <i className="bi bi-map me-2"></i>{t('tourguide-my-tours')}
                    </a>
                </li>
                <li className="nav-item">
                    <a 
                        className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`}
                        onClick={() => handleTabClick('tab3')}
                        href="#tab3"
                    >
                        <i className="bi bi-person me-2"></i>{t('tourguide-profile')}
                    </a>
                </li>
            </ul>
            <div className="tab-content mt-4">
                {activeTab === 'tab1' && <MySchedule />}
                {activeTab === 'tab2' && <MyTours tours={tours} />}
                {activeTab === 'tab3' && <Profile tourGuideProfile={tourGuideProfile} locations={locations} />}
            </div>
        </div>
    )
}

export default ProfileView;
